/* @flow */

// $FlowFixMe
module.exports = require('./dist/paypal-sdk-constants'); // eslint-disable-line import/no-commonjs




//////////////////
// WEBPACK FOOTER
// ../node_modules/paypal-sdk-constants/index.js
// module id = ../node_modules/paypal-sdk-constants/index.js
// module chunks = 0